/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Nav_FaqInputs */

const en_road_dude_nav_faq = /** @type {(inputs: Road_Dude_Nav_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const zh_road_dude_nav_faq = /** @type {(inputs: Road_Dude_Nav_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见问题`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Road_Dude_Nav_FaqInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_nav_faq = /** @type {((inputs?: Road_Dude_Nav_FaqInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Nav_FaqInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_nav_faq(inputs)
	return zh_road_dude_nav_faq(inputs)
});
export { road_dude_nav_faq as "road_dude.nav.faq" }